import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 选择商品 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_NewBoxItemInfoModal = _resolveComponent("NewBoxItemInfoModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.compound,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "商品",
            prop: "product_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.compound.product_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.compound.product_name) = $event)),
                readonly: ""
              }, _createSlots({ _: 2 }, [
                (_ctx.isNew)
                  ? {
                      name: "append",
                      fn: _withCtx(() => [
                        _createVNode(_component_vxe_button, {
                          type: "button",
                          status: "primary",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_new_box_item_info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ])
                    }
                  : undefined
              ]), 1032, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "合成价",
            prop: "price"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.compound.price,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.compound.price) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "库存",
            prop: "stock"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.compound.stock,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.compound.stock) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "排序" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.compound.sorting,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.compound.sorting) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "启用" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.compound.enabled,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.compound.enabled) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "需要流水",
            prop: "water_need"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.compound.water_need,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.compound.water_need) = $event)),
                min: 0
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "每日限制",
            prop: "daily_limit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.compound.daily_limit,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.compound.daily_limit) = $event)),
                min: 0
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "排除素材" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.compound.excluded_product_ids,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.compound.excluded_product_ids) = $event)),
                multiple: "",
                filterable: "",
                remote: "",
                "remote-method": _ctx.searchExcludedProducts,
                loading: _ctx.excludedProductLoading,
                placeholder: "搜索并选择不可作为素材的商品（可多选）",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excludedProductOptions, (product) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: product.id,
                      label: `${product.name} (回收价: ${Number(product.recycle_price).toFixed(2)}元)`,
                      value: product.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "合成类型" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "model-value": _ctx.compound.compound_type === 'card' ? '卡牌' : '商品',
                disabled: ""
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "合成分类" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.compound.compound_category_id,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.compound.compound_category_id) = $event)),
                placeholder: "请选择分类",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCategories, (cat) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: cat.id,
                      label: cat.name,
                      value: cat.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _createVNode(_component_NewBoxItemInfoModal, { add_box_item_infos: _ctx.add_box_item_infos }, null, 8, ["add_box_item_infos"])
  ], 64))
}